import React from "react";
import { createRoot } from 'react-dom/client'
import TrainingCalendar from "./Components/TrainingCalendar/TrainingCalendar";

const CalendarElement = document.getElementById('trainingCalendar');
const root = createRoot(CalendarElement);
root.render(<TrainingCalendar data={events}/>);